import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";
import logoBlincW from "../../../../assets/logo/logo_blinc_w.png";
import logoBlincP from "../../../../assets/logo/logo_blinc_p.png";
import MenuIcon from "../../icons/MenuIcon/MenuIcon";
import { useMenu } from "../../../context/MenuContext";

interface Props {
  theme?: "white" | "red";
}

export default function Header({ theme = "white" }: Props) {
  const { toggleMenu, isOpen } = useMenu();
  const [hover, setHover] = useState(false);

  // 닫을 때 포인터가 버튼 위에 남아 있으면 hover가 true → + 아이콘으로 남는 문제 방지
  useEffect(() => {
    if (!isOpen) setHover(false);
  }, [isOpen]);

  // 오버레이가 열리면 항상 white (red 배경 위)
  const isRed = !isOpen && theme === "red";

  return (
    <header className={`${styles.header} ${isRed ? styles.red : ""}`}>
      <div className={styles.innerRow}>
        <Link to="/" className={styles.logoLink} aria-label="BLINC 홈">
          <div className={styles.logoWrapper}>
            <img src={logoBlincW} alt="BLINC" className={`${styles.logo} ${isRed ? styles.logoHidden : ""}`} />
            <img src={logoBlincP} alt="" aria-hidden className={`${styles.logo} ${isRed ? "" : styles.logoHidden}`} />
          </div>
        </Link>
        <button
          type="button"
          className={styles.menuButton}
          onClick={toggleMenu}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          aria-label={isOpen ? "메뉴 닫기" : "메뉴 열기"}
          aria-expanded={isOpen}
        >
          <span className={styles.menuText}>MENU</span>
          <MenuIcon
            theme={isRed ? "red" : "white"}
            open={isOpen}
            hover={hover && !isOpen}
            className={styles.menuIcon}
          />
        </button>
      </div>
    </header>
  );
}
